export const playSound = (soundFile, volume = 0.5) => {
    try {
      const audio = new Audio(soundFile);
      audio.volume = volume;
      audio.play();
    } catch (e) { console.error("Gagal memutar suara:", e); }
}; 